import {Card, ImageAsset, ImageAssetFactory, ImageAssetType} from '../../domain/card';
import {FormGroup} from '@angular/forms';
import {Component, Input, OnInit} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';

@Component({
  selector: `crds-default-form`,
  template: `
    <div class="card-wrapper">
      <div class="card">
        <div class="card-body">
          <p class="card-text" [innerHTML]="description"></p>
          <crds-image-asset [images]="images" [key]="'default'"></crds-image-asset>
        </div>
      </div>
    </div>
    <div class="form-wrapper">
      <form [formGroup]="form.get(formKey)">
        <crds-questions [form]="form.get(formKey)" [card]="card"></crds-questions>
      </form>
    </div>
    <div *ngIf="description2" class="card-wrapper">
      <div class="card">
        <div class="card-body">
          <p class="card-text" [innerHTML]="description2"></p>
        </div>
      </div>
    </div>
  `
})
export class DefaultFormComponent implements OnInit {
  @Input() card: Card<null>;
  @Input() form: FormGroup;
  @Input() formKey: string;
  action: any;
  description: SafeHtml;
  description2: SafeHtml;
  images: ImageAsset[];
  imageAssetType = ImageAssetType;

  constructor(private imageAssetFactory: ImageAssetFactory) {}

  ngOnInit() {
    this.action = this.card.action;
    this.images = this.imageAssetFactory.create(this.card.image, this.form);
    this.description = this.getCardDescription(this.card.description);
    this.description2 = this.getCardDescription(this.card.description2);
  }

  getCardDescription(description: string) {
    return description ? this._replaceVariables(description, this.form) : null;
  }

  private _getReplaceableMatches(description: string) {
    return description.match(/\{[A-Za-z0-9\.]+\}/g);
  }

  private _replaceVariables(description: string, form: FormGroup): string {
    const matches = this._getReplaceableMatches(description);
    const defaultReplacement = '';
    if (matches) {
      matches.forEach(match => {
        let formValue;
        const matchParts = match.replace(/[{}]/g, '').split('.');
        formValue = this._getFormPartValue(form, matchParts);
        description = description.replace(match, formValue || defaultReplacement);
      });
    }
    return description;
  }

  private _getFormPartValue(form: FormGroup, matchParts: string[], idx: number = 0) {
    const formPart = form.get(matchParts[idx]);
    return typeof formPart.value === 'object' ?
      this._getFormPartValue(formPart as FormGroup, matchParts, idx + 1) :
      formPart.value;
  }
}
